// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__LjCRF","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__Yo0Xm"};